import { __decorate, __param } from '../node_modules/tslib/tslib.es6.js';
import '../vscode-services/missing-services.js';
import { StandaloneServices } from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js';
import { ITextModelService } from 'monaco-editor/esm/vs/editor/common/services/resolverService.js';
import { ICodeEditorService } from 'monaco-editor/esm/vs/editor/browser/services/codeEditorService.js';
import { CodeEditorService } from '../vscode/vs/workbench/services/editor/browser/codeEditorService.js';
import { IEditorService } from '../vscode/vs/workbench/services/editor/common/editorService.js';
import { Emitter, Event } from 'monaco-editor/esm/vs/base/common/event.js';
import { SyncDescriptor } from 'monaco-editor/esm/vs/platform/instantiation/common/descriptors.js';
import { Disposable } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { ITextEditorService, TextEditorService } from '../vscode/vs/workbench/services/textfile/common/textEditorService.js';
import { wrapOpenEditor } from './tools/editor.js';
import { unsupported } from '../tools.js';
import '../vscode/vs/workbench/browser/parts/editor/editor.contribution.js';
let EditorService = class EditorService extends Disposable {
    constructor(_openEditor, textModelService) {
        super();
        this._onDidActiveEditorChange = this._register(new Emitter());
        this.onDidActiveEditorChange = this._onDidActiveEditorChange.event;
        this.onDidVisibleEditorsChange = Event.None;
        this.onDidEditorsChange = Event.None;
        this.onDidCloseEditor = Event.None;
        this.activeTextEditorLanguageId = undefined;
        this.visibleEditorPanes = [];
        this.visibleEditors = [];
        this.visibleTextEditorControls = [];
        this.editors = [];
        this.count = 0;
        this.getEditors = () => [];
        this.openEditors = unsupported;
        this.replaceEditors = unsupported;
        this.isOpened = () => false;
        this.isVisible = () => false;
        this.findEditors = () => [];
        this.save = async () => ({ success: true, editors: [] });
        this.saveAll = async () => ({ success: true, editors: [] });
        this.revert = unsupported;
        this.revertAll = unsupported;
        this.closeEditor = unsupported;
        this.closeEditors = unsupported;
        setTimeout(() => {
            const codeEditorService = StandaloneServices.get(ICodeEditorService);
            this.activeTextEditorControl = codeEditorService.getFocusedCodeEditor() ?? undefined;
            const handleCodeEditor = (editor) => {
                const onEditorFocused = () => {
                    const newFocusedEditor = codeEditorService.getFocusedCodeEditor();
                    if (newFocusedEditor !== this.activeTextEditorControl) {
                        this.activeTextEditorControl = newFocusedEditor ?? undefined;
                        this._onDidActiveEditorChange.fire();
                    }
                };
                editor.onDidFocusEditorText(onEditorFocused);
                editor.onDidFocusEditorWidget(onEditorFocused);
            };
            this._register(codeEditorService.onCodeEditorAdd(handleCodeEditor));
            codeEditorService.listCodeEditors().forEach(handleCodeEditor);
        });
        this.openEditor = wrapOpenEditor(textModelService, this.openEditor.bind(this), _openEditor);
    }
    async openEditor() {
        return undefined;
    }
};
EditorService = __decorate([
    ( __param(1, ITextModelService))
], EditorService);
function getServiceOverride(openEditor) {
    return {
        [( ICodeEditorService.toString())]: new SyncDescriptor(CodeEditorService, undefined, true),
        [( IEditorService.toString())]: new SyncDescriptor(EditorService, [openEditor]),
        [( ITextEditorService.toString())]: new SyncDescriptor(TextEditorService)
    };
}
export { getServiceOverride as default };
